import { Component } from '@angular/core';
import { FeaturePreviewComponent } from '../feature-preview.component';

@Component({
  selector: 'app-feature-preview-tidrapport',
  templateUrl: './tidrapport.component.html',
})
export class FeaturePreviewTidrapport extends FeaturePreviewComponent {}
